/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { AnimatedLoadingPlaceholder } from '../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { numberOfAqiListItemsLoading } from '../../constants';

const loadingTextList = numberOfAqiListItemsLoading(3);

export const AirQualitySubStoryLoadingUI = () => {
    return (
        <Card>
            <Anchor href='#'>
                <Thumbnail>
                    <AnimatedLoadingPlaceholder height='100%' radius={0.1} />
                </Thumbnail>
                <Info>
                    {loadingTextList.map((aqiStoryTextLoadingNumber: number, index: number) => {
                        const adjustedWidth = index === loadingTextList.length - 1 ? 80 : 0;
                        return (
                            <AnimatedLoadingPlaceholder key={aqiStoryTextLoadingNumber} width={adjustedWidth} />
                        );
                    })}
                </Info>
            </Anchor>
        </Card>
    );
};

const Card = styled.li`
    margin-top: 6px;
    padding: 5px 10px 5px 0;
    width: 50%;
    display: inline-block;
    height: 150px;

    @media ${smallMediaQuery} {
        width: 100%;
        margin: 6px 0 0 0;
        padding-right: 0;
    }
`;

const Anchor = styled.a`
    text-decoration: none;
    display: flex;
    flex-direction: row;
`;

const Thumbnail = styled.div`
    width: 40%;
    height: 148px;
    border-radius: 2px 0 0 2px;
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    background-color: white;
    overflow: hidden;
    width: 60%;
    padding: 12px 16px;
    height: 148px;
    color: #455560;
    float: right;
`;
